import { EndpointsEnum } from '../endpoints.enum';

export const UpdateSuccessMessageMapper = new Map<EndpointsEnum, string>([[EndpointsEnum.CONFIGS, 'S_CONFIG_130']]);

export const UpdateErrorMessageMapper = new Map<EndpointsEnum, string>([[EndpointsEnum.CONFIGS, 'S_CONFIG_131']]);
